import { $, $$, closest } from 'utils/dom';
import { delay } from 'utils/helper';
import EventListener from 'utils/event-listener';
import Slider from 'modules/Slider/Slider';

const heroes = $$('.hero-header');
heroes.length &&
  heroes.forEach(hero => {
    const $$itemWrappers = $$('.hero-header__container', hero);
    const $target = $('.hero-header__items', hero);
    const $$slides = $$('.hero-header__item', $target);
    let slidesLength = 0;
    let iterations = 0;
    let repeats = 0;
    let distance = 0;
    let slideOld = 0;
    let slideBeforeOnChange = 0;
    const randomIndex = Math.floor(Math.random() * $$slides.length);

    const Carousel = new Slider($target, {
      gap: '5rem',
      config: {
        cellAlign: 'center',
        groupCells: false,
        prevNextButtons: false,
        wrapAround: true,
        contain: false,
        initialIndex: randomIndex,
      },
      enableA11y: false,
      events: {
        onChange: (index, slider) => {
          // only for odd slides number necessary to note the iterations
          distance = slideOld - slideBeforeOnChange;
          distance = distance < 0 ? -distance : distance;
          if (distance > slider.slideableWidth / 2) {
            iterations -= 1;
          }
          distance = slideOld - slider.x;
          distance = distance < 0 ? -distance : distance;
          if (distance > slider.slideableWidth / 2) {
            iterations += 1;
          }
          slideOld = slider.x;
        },
        onScroll: (progress, sliderX, slider) => {
          // only for odd slides number necessary to find focused slide
          let focus = 0;
          if (slidesLength % 2) {
            let min = slider.slideableWidth;
            slideBeforeOnChange = slider.x;
            repeats = parseInt(slider.x / slider.slideableWidth);

            slider.slides.forEach((slide, i) => {
              let move = (slider.x % slider.slideableWidth) + slide.target;
              if (move > slider.slideableWidth / 2) {
                move = slider.slideableWidth - move;
              } else if (move < -slider.slideableWidth / 2) {
                move = -slider.slideableWidth - move;
              }
              move = move < 0 ? -move : move;
              min = min < move ? min : move;
              focus = min < move ? focus : i;
            });
          }

          slider.slides.forEach((slide, i) => {
            let move = (slider.x % slider.slideableWidth) + slide.target;
            let waveMove;
            // FIXME: fix opacity for shifted items
            const pos =
              (-(slider.x % slider.slideableWidth) - slide.target) /
              slide.outerWidth;
            const posAbsolute = Math.abs(pos);
            const minMaxOpacity = posAbsolute > 1 ? 1 : posAbsolute;
            const opacity = (1 - minMaxOpacity).toFixed(2);

            if (slidesLength % 2) {
              // for odd slides number
              if (move > slider.slideableWidth / 2) {
                move = slider.slideableWidth - move;
              } else if (move < -slider.slideableWidth / 2) {
                move = -slider.slideableWidth - move;
              }
              let difference = i < focus ? focus - i : i - focus;
              if (difference > slidesLength / 2) {
                move = -move;
              } else {
                difference = slidesLength - difference;
              }
              waveMove =
                (difference + focus + repeats + iterations) % 2 ? move : -move;
            } else {
              // for even slides number
              if (move > slider.slideableWidth / 2) {
                move = move - slider.slideableWidth;
              } else if (move < -slider.slideableWidth / 2) {
                move = move + slider.slideableWidth;
              }
              waveMove = i % 2 ? move : -move;
            }

            $$itemWrappers[i].style.transform =
              'translateY( ' + (waveMove / 20).toFixed(2) + 'px)';
            $('.hero-header__text', $$itemWrappers[i]).style.opacity = opacity;
          });
        },
        onDestroy: () => {
          $$itemWrappers.forEach($wrapper => {
            $wrapper.style.transform = 'none';
          });
        },
      },
    });

    Carousel.init({
      on: {
        ready: () => {
          isSliderReady();
          new EventListener('resize orientationchange', null, () => {
            Carousel.slider.resize();
          }).listen();

          $$('a, button', $target).forEach(a =>
            a.addEventListener('focus', e => {
              const slide = closest(e.target, '.hero-header__item');
              Carousel.handleSlideFocus({ target: slide });
            })
          );
        },
      },
    });

    const isSliderReady = async (timeout = 0) => {
      try {
        await delay(timeout);
        const { slider, target } = Carousel;
        /**
         * Slider is not ready instantly, so we do a reposition on the
         * next tick, so we show the slider in the proper start position
         */
        setTimeout(() => {
          slider.reposition();
          target.classList.add('is-ready');
        }, 0);
        slideOld = slider.x;
        slidesLength = slider.slides.length;
      } catch (err) {
        isSliderReady(100);
      }
    };
  });
